
import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Badge } from '@/components/ui/badge';
import { formatDistanceToNow } from 'date-fns';
import { type Gift } from '@/utils/types';

interface TransactionItemProps {
  gift: Gift;
  isSelected: boolean;
  onSelect: (gift: Gift) => void;
}

const TransactionItem: React.FC<TransactionItemProps> = ({ gift, isSelected, onSelect }) => {
  return (
    <div 
      key={gift.id} 
      className={`border rounded-lg p-3 flex justify-between items-center cursor-pointer transition-all ${
        isSelected ? 'bg-givgo-light border-givgo-purple' : 'hover:bg-gray-50'
      }`}
      onClick={() => onSelect(gift)}
    >
      <div className="flex items-center gap-3">
        <Checkbox 
          checked={isSelected}
          onCheckedChange={() => onSelect(gift)}
          onClick={e => e.stopPropagation()}
        />
        <div>
          <div className="font-medium">${gift.amount} GivGo Bucks</div>
          <div className="text-xs text-muted-foreground">
            ID: {gift.id.substring(0, 8)}... • Received {formatDistanceToNow(gift.createdAt, { addSuffix: true })}
          </div>
        </div>
      </div>
      <Badge variant="outline" className="text-sm">
        ${gift.amount}
      </Badge>
    </div>
  );
};

export default TransactionItem;
